/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, memo, useContext } from 'react';
import {
  Button,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { CalendarCancel24Regular } from '@fluentui/react-icons';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

interface IStopGeneratingProps {
  onClickStopGenerating?: () => void;
}

const useStopGeneratingStyles = makeStyles({
  container: {
    marginTop: tokens.spacingVerticalM,
    textAlign: 'center',
  },
});

export const StopGenerating: FC<IStopGeneratingProps> = memo(({ onClickStopGenerating }) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const styles = useStopGeneratingStyles();

  return (
    <div className={mergeClasses('ads-copilot-stop-generating-container', styles.container)}>
      <Button
        appearance="transparent"
        icon={<CalendarCancel24Regular />}
        className="ads-copilot-stop-generating-btn"
        onClick={onClickStopGenerating}
      >
        {i18n.getString(_TL_('Stop Generating'))}
      </Button>
    </div>
  );
});
